<template>
  <v-container fluid id="loginCss" fill-height>
    <!-- :style="image" -->
    <ul class="circles">
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	  </ul>

		<v-row justify="center" v-if="isMobile">
	  	<v-col cols="9">
				<v-card class="transparent elevation-0 text--center" align="center" id="button-0" @click="abrirLogin()">
				  <v-img 
				  	src="@/assets/fondos/logo.png" 
				  	max-width="250" 
				  	class="text--center align-end" 
				  	v-if="escuela && escuela == 1"
				  >
				  	<div class="white--text">
							<v-btn color="grey" class="elevation-4" dark rounded>Click me!</v-btn>
						</div>
					</v-img>

					<v-img 
						src="@/assets/fondos/logo_fast.png" 
						max-width="250"
						class="text--center align-end" 
						v-if="escuela && escuela == 2"
					>
						<div class="white--text">
							<v-btn color="grey" class="elevation-4" dark rounded>Click me!</v-btn>
						</div>
					</v-img>
				</v-card>
	  	</v-col>
		</v-row>

		<v-row justify="center" v-else>
	  	<v-col cols="9">
				<v-card class="transparent white--text elevation-0 text--center text-h4" align="center" id="button-0" >
					<span>Porfavor, instala la aplicación</span>
				</v-card>
	  	</v-col>
		</v-row>
  </v-container>
</template>

<script>
	import { mapGetters } from 'vuex'
	export default {
	  data: () => ({
    	escuela: null,
	    // image: { backgroundImage: `url(${ require('@/assets/fondos/fondo_login.png') })` }
	    toMatch : [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    	],
    	isMobile: false
	  }),

	  computed: {
	  	...mapGetters( 'login', [ 'getLogeadoLMS', 'getDatosUsuarioLMS', 'getUsuarioLMS' ]),
	  },

	  created () {
	  	this.escuela = this.$store.state.ESCUELA 

	  	this.isMobile = this.toMatch.some((toMatchItem) => {
	  		// web
	      // return navigator.userAgent.match(toMatchItem);

	      // movil 
	      return true;
	    });

	    if (this.$store.getters['loginVendedora/getLogeadoVendedora']) {
	      this.$router.push({ name: 'VendedoraListaChats' })
	      return
	    }

	    if( !this.getUsuarioLMS ) return 

	  	if( this.getUsuarioLMS.roll == 'ALUMNO'){
	  		this.$router.push({ name: 'Perfil' })
	  	}

	  	if( this.getUsuarioLMS.roll == 'TEACHER'){
	  		this.$router.push({ name: 'PerfilTeacher' })
	  	}


	  	if( this.getUsuarioLMS.roll == 'EDITOR'){
	  		this.$router.push({ name: 'IngresarSucursal' })
	  	}
	  },

	  methods:{
	  	abrirLogin (){
	  		this.$router.push({name: 'Login'})
	  	}
	  }
	}
</script>
